// Dependencies
import { h, Component } from "preact";
import { connect } from "react-redux";

// Components
import WidgetComponent from "components/WidgetComponent";
import {
	Form,
	FormEntry,
	I18n,
	Button,
	Container,
	Col,
	Row,
} from "components/elements";
import {
	FACheckCircle,
	FADotCircle,
} from "components/elements/FontAwesome";
import LoadingIcon from "components/elements/LoadingIcon";

// Actions
import { AccountActions, PageActions, PatientActions } from "actions";


// Styles
import style from "./index.less";

// Icons
import showIcon from "../../../assets/icons/svg/eye.svg";
import hideIcon from "../../../assets/icons/svg/eye_off.svg";

@Form
@connect((state) => state)
export default class ResetPrompt extends WidgetComponent {
	constructor(props, context) {
		super(props, context);
		this.state = {
			passwordError: false,
			resetError: false,
			resetSent: false,
			showPassword: false,
			value: "",
		};
		this.handleResetPassword = this.handleResetPassword.bind(this);
		this.handlePassword = this.handlePassword.bind(this);
		this.handlePasswordConfirmation =
			this.handlePasswordConfirmation.bind(this);
		this.handleShowPassword = this.handleShowPassword.bind(this);
	}

	handleResetPassword(values) {
		if (
			values.password &&
			values.confirmPassword &&
			values.password == values.confirmPassword
		) {
			this.setState({
				submittingPassword: true,
				passwordError: false,
				passwordErrorMessage: "",
			});
			AccountActions.update({
				password: values.password,
				passwordConfirmation: values.confirmPassword,
			})
				.then((response) => {
					this.setState({
						submittingPassword: false,
					});
					PatientActions.fetch({ organizationID: this.props.organization.id });
					PageActions.navToFilters();
				})
				.catch((e) => {
					this.setState({
						submittingPassword: true,
					});
					e = (e.response.data || {}).errors || "";

					let errorMessage = [];
                    console.log({e});
					if (e.includes("min")) {
						errorMessage.push(I18n.t("passwordRuleLeastCharacters"));
					}
					if (e.includes("uppercase")) {
						errorMessage.push(I18n.t("passwordRuleLeastUppercaseLetter"));
					}
					if (e.includes("digits")) {
						errorMessage.push(I18n.t("passwordRuleLeastNumber"));
					} 
                    
                    if(e === ""){
                        errorMessage.push(I18n.t("itDoesNotMeetOneOrMoreOfTheCriteria"));
                    }

					this.setState({
						submittingPassword: false,
						passwordError: true,
						passwordErrorMessage: `${I18n.t("invalidPassword")}: ${errorMessage.join(
							", "
						)}`,
					});
				});
		} else {
			this.setState({
				submittingPassword: false,
				passwordError: true,
				passwordErrorMessage: `Passwords do not match`,
			});
		}
	}

	handlePassword(e) {
		const value = e.target.value;
		this.setState({
			passwordValue: value,
			passwordConfirmationMatches:
				value == this.state.passwordConfirmationValue,
			hasNumber: value.match(/(?=.*\d)/),
			hasLowerCase: value.match(/(?=.*[a-z])/),
			hasUpperCase: value.match(/(?=.*[A-Z])/),
			hasEightCharacters: value.match(/(?=.{8,8})/),
		});
	}

	handlePasswordConfirmation(e) {
		const value = e.target.value;
		this.setState({
			passwordConfirmationValue: value,
			passwordConfirmationMatches: value == this.state.passwordValue,
		});
	}
	handleShowPassword() {
		this.setState({
			showPassword: !this.state.showPassword,
		});
	}

	render() {
		const { InputDark, Form } = this.props;
		return (
			<Form class={style.passwordResetForm} onSubmit={this.handleResetPassword}>
				<Container class={`${this.props.class || ""} ${style.containerView}`}>
					<Row>
						<Col class={style.inputsContainer}>
							<div class={style.item}>
								<div className={style.itemTitle}>
									<I18n>newPassword</I18n>
								</div>
								<button
									className={style.showPasswordBtn}
									type="button"
									class={style.passwordButton}
									onClick={this.handleShowPassword}
								>
									<img
										src={this.state.showPassword ? hideIcon : showIcon}
										alt="Show Password"
									/>
								</button>
								<FormEntry>
									<InputDark
										name="password"
										onChange={this.handlePassword}
										required={true}
										question={I18n.t("password")}
										type={this.state.showPassword ? "text" : "password"}
									/>
								</FormEntry>
							</div>
							<div class={style.item}>
								<div className={style.itemTitle}>
									<I18n>confirmNewPassword</I18n>
								</div>
								<button
									className={style.showPasswordBtn}
									type="button"
									class={style.passwordButton}
									onClick={this.handleShowPassword}
								>
									<img
										src={this.state.showPassword ? hideIcon : showIcon}
										alt="Show Password"
									/>
								</button>
								<FormEntry>
									<InputDark
										name="confirmPassword"
										onChange={this.handlePasswordConfirmation}
										required={true}
										question={I18n.t("confirmPassword")}
										type={this.state.showPassword ? "text" : "password"}
									/>
								</FormEntry>
							</div>
							{this.state.passwordError  && (
								<div class={style.errorMessage}>
									{this.state.passwordErrorMessage}
								</div>
							)}
							<div className={style.passwordRules}>
								<div className={style.rule}>
									{this.state.hasNumber ? (
										<FACheckCircle class={style.checkedColor} />
									) : (
										<FADotCircle class={style.openColor} />
									)}{" "}
									<I18n>passwordRuleLeastNumber</I18n>
								</div>
								<div className={style.rule}>
									{this.state.hasUpperCase ? (
										<FACheckCircle class={style.checkedColor} />
									) : (
										<FADotCircle class={style.openColor} />
									)}{" "}
									<I18n>passwordRuleLeastUppercaseLetter</I18n>
								</div>
								<div className={style.rule}>
									{this.state.hasLowerCase ? (
										<FACheckCircle class={style.checkedColor} />
									) : (
										<FADotCircle class={style.openColor} />
									)}{" "}
									<I18n>passwordRuleLeastLowercaseLetter</I18n>
								</div>
								<div className={style.rule}>
									{this.state.hasEightCharacters ? (
										<FACheckCircle class={style.checkedColor} />
									) : (
										<FADotCircle class={style.openColor} />
									)}{" "}
									<I18n>passwordRuleLeastCharacters</I18n>
								</div>
								<div className={style.rule}>
									{this.state.passwordConfirmationMatches ? (
										<FACheckCircle class={style.checkedColor} />
									) : (
										<FADotCircle class={style.openColor} />
									)}{" "}
									<I18n>passwordRuleConfirmationMatched</I18n>
								</div>
							</div>
						</Col>
						<Col class={style.searchButton}>
							{this.state.submittingPassword ? (
								<div className={style.loadingAnimation}>
									<LoadingIcon size={75}/>
								</div>
							) : (
								<Button>Submit</Button>
							)}
						</Col>
					</Row>
				</Container>
			</Form>
		);
	}
}



// WEBPACK FOOTER //
// ./components/partials/PasswordReset/index.js